import { Typography } from "@mui/material";
import { isEqual } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomConfirmationChangesDialog from "../../../../../../containers/CustomConfirmationChangesDialog/CustomConfirmationChangesDialog";
import { EXPENSE_REPORT_STATUS } from "../../../../../../utils/constants/constants";
import { ExpenseReportStatusType } from "../../AddEditExpenseReport";

interface Props {
  managerUpdatedStatus: ExpenseReportStatusType | null;
  managerUpdatedDocStatus: boolean;
  handleSave: () => Promise<void>;
  parentIsLoading: boolean;
  isCCCDOpen: boolean;
  handleCloseCCCCD: () => void;
}

const ManagerConfirmationDialog = ({
  managerUpdatedDocStatus,
  managerUpdatedStatus,
  handleSave,
  parentIsLoading,
  isCCCDOpen,
  handleCloseCCCCD,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "pages.manage_travel_and_expenses.tables.expense_reports.expense_report_details";

  return (
    <CustomConfirmationChangesDialog
      open={isCCCDOpen}
      loading={parentIsLoading}
      title={
        managerUpdatedDocStatus
          ? t(`${tRP}.CCCD_title_update_doc_status`)
          : managerUpdatedStatus
          ? t(`${tRP}.CCCD_title_update_status`)
          : ""
      }
      handleCancel={handleCloseCCCCD}
      actionsAndHandlers={[
        {
          action: "yes",
          buttonVariant: "contained",
          handler: handleSave,
        },
      ]}
    >
      {managerUpdatedDocStatus ? (
        t(`${tRP}.documentation_update_message`)
      ) : managerUpdatedStatus ? (
        isEqual(managerUpdatedStatus.id, EXPENSE_REPORT_STATUS.returned_to_employee.id) ? (
          <Typography>{`${t(`${tRP}.return_to_employee_message`)}`}</Typography>
        ) : isEqual(managerUpdatedStatus.id, EXPENSE_REPORT_STATUS.paid.id) ? (
          <Typography>{`${t(`${tRP}.mark_as_paid_message`)}`}</Typography>
        ) : isEqual(managerUpdatedStatus.id, EXPENSE_REPORT_STATUS.rejected.id) ? (
          <Typography>{`${t(`${tRP}.reject_message`)}`}</Typography>
        ) : isEqual(managerUpdatedStatus.id, EXPENSE_REPORT_STATUS.approved.id) ? (
          <Typography>{`${t(`${tRP}.approve_message`)}`}</Typography>
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </CustomConfirmationChangesDialog>
  );
};

export default ManagerConfirmationDialog;
